module.exports = __webpack_public_path__ + "img/4d69d09.jpg";